module.exports = __webpack_public_path__ + "static/corona-banner-mobile.e5cabd8a.png";